import React from 'react';

export class LoaderFlake extends React.Component {

    render() {
        return(
            <span className="flake_loader">
                <svg width="58.789" height="64" viewBox="0 0 58.789 64">
                    <g transform="translate(0 0)">
                        <g transform="translate(0 0)">
                            <path fill="#fff"
                                  d="M55.977,50.366a.741.741,0,0,1-1.026.194l-5.734-3.887.638,3.523a.736.736,0,0,1-1.312.565.76.76,0,0,1-.14-.31l-.887-4.938-5.679-3.845,1.172,6.463a.739.739,0,0,1-1.312.577.821.821,0,0,1-.146-.322l-1.427-7.878-5.387-3.65,1.2,6.542,2.01,2.01a.73.73,0,0,1-.006,1.033.9.9,0,0,1-.164.1.718.718,0,0,1-.881-.1l-.5-.5.188,1.057a.731.731,0,0,1-.6.856h-.006a.745.745,0,0,1-.7-.279.65.65,0,0,1-.14-.316L34.554,44.1l-5.236-5.236L28.8,45.683l5.242,5.952h-.006a.718.718,0,0,1-.067,1.026A.745.745,0,0,1,32.92,52.6l-4.282-4.871-.516,6.784L31.378,58.2v.006a.731.731,0,0,1-.067,1.033.752.752,0,0,1-1.045-.073l-2.3-2.612-.516,6.766a.737.737,0,0,1-1.47-.109l.528-6.87-2.758,2.314a.738.738,0,0,1-1.033-.091.722.722,0,0,1-.128-.747.674.674,0,0,1,.207-.279L26.658,54.3l.516-6.791-5.06,4.233a.733.733,0,0,1-1.154-.838.66.66,0,0,1,.207-.279l6.165-5.169.492-6.438L22.71,43.3l-.747,2.727a.734.734,0,0,1-.911.516,1.056,1.056,0,0,1-.164-.085.73.73,0,0,1-.352-.808l.188-.692-.826.7a.746.746,0,0,1-1.045-.085v-.006a.763.763,0,0,1-.121-.747.731.731,0,0,1,.213-.279l2.46-2.065,1.944-7.112-6.2,2.958-2.575,7.471h-.006a.738.738,0,0,1-1.4-.474L15.276,39.2,9.1,42.148l-1.6,4.64a.741.741,0,0,1-1.4-.474l1.142-3.28L1.051,45.969a.728.728,0,1,1-.632-1.312l6.256-2.982L3.286,40.46a.727.727,0,0,1-.449-.929.751.751,0,0,1,.6-.48.856.856,0,0,1,.346.036l4.756,1.7,6.189-2.946L8.5,35.613a.718.718,0,0,1-.437-.935.738.738,0,0,1,.941-.437L16.6,36.955l5.879-2.8-6.3-2.247-2.758.723a.741.741,0,0,1-.905-.528.6.6,0,0,1-.012-.182.714.714,0,0,1,.534-.7l.692-.182L12.7,30.669a.732.732,0,0,1-.437-.935v-.006a.764.764,0,0,1,.6-.474.834.834,0,0,1,.346.036l3.031,1.087,7.2-1.883-5.691-3.851L9.925,26.162a.74.74,0,0,1-.862-.583.73.73,0,0,1,.571-.856l6.4-1.239-5.661-3.845-4.853.948H5.509a.753.753,0,0,1-.869-.577.736.736,0,0,1,.589-.862l3.426-.662L3,14.646a.721.721,0,0,1-.194-1.014.745.745,0,0,1,1.026-.188l5.74,3.887-.65-3.517a.738.738,0,1,1,1.452-.261l.9,4.938,5.679,3.845-1.178-6.469a.716.716,0,0,1,.6-.838.706.706,0,0,1,.711.267.62.62,0,0,1,.14.316l1.439,7.878,5.375,3.65L22.856,20.6l-2.01-2a.737.737,0,0,1,0-1.039c.049-.043.109-.067.158-.1a.744.744,0,0,1,.887.109l.5.5-.188-1.063a.727.727,0,0,1,.589-.85H22.8a.767.767,0,0,1,.717.273.96.96,0,0,1,.14.322l.571,3.14,5.242,5.242.516-6.809-5.236-5.958a.726.726,0,0,1,.067-1.033.739.739,0,0,1,1.039.073l4.282,4.871L30.661,9.5,27.405,5.8h.006a.726.726,0,0,1,.067-1.033.74.74,0,0,1,1.045.073l2.3,2.612L31.341.676a.734.734,0,0,1,1.464.115l-.522,6.863L35.04,5.347a.741.741,0,0,1,1.039.091.714.714,0,0,1,.109.753.667.667,0,0,1-.2.279L32.131,9.7l-.516,6.791,5.053-4.233a.739.739,0,0,1,1.039.085.693.693,0,0,1,.115.747.643.643,0,0,1-.207.285l-6.165,5.163-.492,6.444,5.12-4.282.747-2.733a.741.741,0,0,1,.9-.516,1.6,1.6,0,0,1,.176.091.716.716,0,0,1,.346.814l-.188.68.832-.692a.734.734,0,0,1,1.039.085h.006a.731.731,0,0,1,.109.747.765.765,0,0,1-.2.285l-2.466,2.059-1.95,7.119,6.214-2.952,2.575-7.477a.74.74,0,0,1,.935-.456.729.729,0,0,1,.462.929L43.507,24.8l6.183-2.94,1.6-4.646h.006a.734.734,0,0,1,.935-.449.724.724,0,0,1,.456.923l-1.13,3.286,6.171-2.94a.749.749,0,0,1,.99.34.74.74,0,0,1-.352.984l-6.256,2.976L55.5,23.538a.718.718,0,0,1,.443.935.709.709,0,0,1-.589.474.735.735,0,0,1-.346-.03l-4.762-1.7-6.2,2.946,6.232,2.223a.736.736,0,0,1,.449.935.751.751,0,0,1-.6.48.624.624,0,0,1-.346-.043l-7.592-2.709L36.31,29.843l6.3,2.247,2.764-.717a.752.752,0,0,1,.905.522.93.93,0,0,1,.006.182.722.722,0,0,1-.534.711l-.692.182,1.02.364a.735.735,0,0,1,.449.941H46.52a.746.746,0,0,1-.6.474.834.834,0,0,1-.346-.036l-3.037-1.087-7.185,1.883,5.679,3.851,7.823-1.518v.006a.731.731,0,1,1,.285,1.433l-6.39,1.239,5.667,3.839,4.853-.941v.006a.731.731,0,1,1,.292,1.433l-3.444.662,5.661,3.833a.723.723,0,0,1,.194,1.014M34.439,30.729l-2.691,1.282-.905.437.128.091.249.17.176.115,2.344,1.591L40.1,32.758ZM29.4,32.084l.073-.049-.006-.079-.079-.036-.067.049a.181.181,0,0,1,.006.079l.073.036m1.409-5.053-.225,2.952-.079,1,.14-.073.279-.134.194-.085,2.557-1.221L35.4,23.18ZM25.759,28.3l2.466,1.67.832.565.012-.158.024-.3.006-.213.225-2.812L24.69,22.432Zm-1.415,4.974,2.691-1.282.911-.437-.134-.091-.243-.17-.182-.115-2.344-1.591-6.353,1.664Zm3.638,3.7.219-2.946.085-1-.152.061-.267.134-.2.085L25.11,34.532l-1.725,6.286ZM33.024,35.7,30.57,34.04l-.838-.571-.012.152-.024.3-.018.213-.213,2.806,4.628,4.628Z"
                                  transform="translate(0 -0.001)"/>
                        </g>
                    </g>
                </svg>
            </span>
        )
    }
}

export class AppLoadingScreen extends React.Component {

    render() {
        return(
            <div className="app_loading_screen"><LoaderFlake /></div>
        )
    }
}

export class Cam extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(2 5)">
                    <path fill="#ffd83e" opacity="0.4"
                          d="M3.743.216A1.383,1.383,0,0,0,2.37.152L.888.9A1.618,1.618,0,0,0,0,2.356V8.19A1.622,1.622,0,0,0,.888,9.647l1.481.747A1.372,1.372,0,0,0,3,10.547a1.4,1.4,0,0,0,.743-.216,1.429,1.429,0,0,0,.669-1.218V1.435A1.432,1.432,0,0,0,3.743.216"
                          transform="translate(15.588 2.226)"/>
                    <path fill="#ffd83e"
                          d="M9.905,15H4.113A3.91,3.91,0,0,1,0,10.939V4.061A3.91,3.91,0,0,1,4.113,0H9.905a3.91,3.91,0,0,1,4.113,4.061v6.878A3.91,3.91,0,0,1,9.905,15"
                          transform="translate(0 0)"/>
                </g>
            </svg>
        )
    }
}

export class Calendar extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(3 2)">
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M0,.473H17.824" transform="translate(0.093 6.931)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(12.984 10.837)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(8.546 10.837)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(4.099 10.837)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(12.984 14.723)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(8.546 14.723)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.459.473H.468" transform="translate(4.099 14.723)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.463,0V3.291" transform="translate(12.581 0)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a" d="M.463,0V3.291" transform="translate(4.502 0)"/>
                    <path fill="none" stroke="#afebff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" className="a"
                          d="M13.238,0H4.771C1.834,0,0,1.636,0,4.643v9.05c0,3.054,1.834,4.728,4.771,4.728h8.458c2.946,0,4.771-1.645,4.771-4.652V4.643C18.009,1.636,16.184,0,13.238,0Z"
                          transform="translate(0 1.579)"/>
                </g>
            </svg>
        )
    }
}

export class VideoPreviewBtnPlay extends React.Component {

    render() {
        return(
            <svg width="24" height="32" viewBox="0 0 24 32">
                <path d="M14.336,2.5a2,2,0,0,1,3.328,0L29.927,20.891A2,2,0,0,1,28.263,24H3.737a2,2,0,0,1-1.664-3.109Z" transform="translate(24) rotate(90)" fill="#fff"/>
            </svg>
        )
    }
}

export class VideoUploadIcon extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(2 2)">
                    <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"/>
                    <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5"
                          d="M5.16,3.969A14.915,14.915,0,0,1,1.432,6.512a3.983,3.983,0,0,1-.664.214.5.5,0,0,1-.459-.27,5.24,5.24,0,0,1-.166-.689A16.6,16.6,0,0,1,0,3.364,15.624,15.624,0,0,1,.158.879C.186.723.268.364.292.306A.5.5,0,0,1,.518.06.494.494,0,0,1,.768,0a3.49,3.49,0,0,1,.575.178A14.782,14.782,0,0,1,5.15,2.746c.068.073.255.269.286.309a.5.5,0,0,1,.011.6C5.414,3.7,5.223,3.9,5.16,3.969Z"
                          transform="translate(7.89 6.498)"/>
                </g>
            </svg>
        )
    }
}

export class PhotoUploadIcon extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <rect width="24" height="24" fill="none"/>
                <g transform="translate(2 3)">
                    <path d="M14.888,3.36h0a.962.962,0,0,1-.87-.551C13.731,2.2,13.366,1.424,13.15,1A1.675,1.675,0,0,0,11.6,0c-.012,0-4.684,0-4.7,0A1.676,1.676,0,0,0,5.35,1c-.215.423-.58,1.2-.867,1.808a.963.963,0,0,1-.87.551h0A3.612,3.612,0,0,0,0,6.972v5.936A3.613,3.613,0,0,0,3.613,16.52H14.888A3.612,3.612,0,0,0,18.5,12.908V6.972A3.612,3.612,0,0,0,14.888,3.36Z"
                          transform="translate(0.75 0.75)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5"/>
                    <path d="M0,3.182A3.179,3.179,0,1,0,3.182,0,3.19,3.19,0,0,0,0,3.182Z" transform="translate(6.821 7.152)"
                          fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5"/>
                    <path d="M.9,2a1.085,1.085,0,0,1-.3-.078A1.008,1.008,0,0,1,.282,1.7,1.021,1.021,0,0,1,0,1,.971.971,0,0,1,.082.607,1.018,1.018,0,0,1,.318.265,1.144,1.144,0,0,1,.622.07,1.023,1.023,0,0,1,1.7.285a.962.962,0,0,1,.19.261L1.917.6A.974.974,0,0,1,2,1a1.016,1.016,0,0,1-.292.705A1,1,0,0,1,1.1,2L1,2Z"
                          transform="translate(14 6)"/>
                </g>
            </svg>

        )
    }
}

export class CheckboxTick extends React.Component {

    render() {
        return(
            <svg width="11.241" height="7.557" viewBox="0 0 11.241 7.557">
                <path d="M-1,1.373,2.374,4.746,8.12-1" transform="translate(2.061 2.061)"
                      fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"
                      strokeWidth="1.5"/>
            </svg>


        )
    }
}

export class CloseCross extends React.Component {

    render() {
        return(
            <svg width="18.121" height="18.121" viewBox="0 0 18.121 18.121">
                <g transform="translate(-934.939 -70.939)">
                    <line fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1.5" x2="16" y2="16" transform="translate(936 72)"/>
                    <line fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1.5" x1="16" y2="16" transform="translate(936 72)"/>
                </g>
            </svg>

        )
    }
}

export class ArrowDown extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(5 8.5)">
                    <path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" d="M14,0,7,7,0,0"/>
                </g>
            </svg>
        )
    }
}


export class Star extends React.Component {

    render() {
        return(
            <svg className="star" width="17.914" height="17.128" viewBox="0 0 17.914 17.128">
                <path fill="#ffd83e" stroke="#d5ac26"
                      d="M8.615,1.684a1,1,0,0,1,1.77,0L12.31,5.344a1,1,0,0,0,.718.521l4.083.691a1,1,0,0,1,.547,1.687l-2.891,2.945a1,1,0,0,0-.276.846l.6,4.079a1,1,0,0,1-1.432,1.043L9.943,15.321a1,1,0,0,0-.885,0L5.339,17.156a1,1,0,0,1-1.432-1.043l.6-4.079a1,1,0,0,0-.276-.846L1.342,8.242a1,1,0,0,1,.547-1.687l4.083-.691a1,1,0,0,0,.718-.521Z"
                      transform="translate(-0.543 -0.649)"/>
            </svg>
        )
    }
}

export class SliderArrow extends React.Component {

    render() {
        return(
            <svg width="24" height="24" viewBox="0 0 24 24">
                <rect className="a" width="24" height="24"/>
                <g transform="translate(15.5 5) rotate(90)">
                    <path className="b" d="M14,0,7,7,0,0"/>
                </g>
            </svg>
        )
    }
}